import { Modal } from "common/Modal"
import { Table } from "common/Table/Table"
import { useNotifications } from "hooks/useNotification"
import {
  Fragment,
  SyntheticEvent,
  useCallback,
  useEffect,
  useState,
} from "react"
import UserService from "services/user.service"
import { exportToCSV, formatDate } from "utils/funcs"
import CreatableSelect from "react-select/creatable"
import swal from "sweetalert"
import { useRouter } from "hooks/useRouter"
import { formatPhone } from "./Contacts"

const service = new UserService()

const HIERARCHY = [
  "VP",
  "Partner",
  "Senior Regional",
  "Regional",
  "Senior Manager",
  "Manager",
  "Team Lead",
  "Recruiter",
  "Rep",
]

export const Dealership = () => {
  const router = useRouter()
  const columns = [
    { key: "companyId", dbColName: "companyId", title: "company id" },
    { key: "title", dbColName: "title", title: "Company Name" },
    {
      key: "fullname",
      dbColName: "owner",
      title: "full name",
      render: (owner) => owner?.fullname,
    },
    {
      key: "email",
      dbColName: "owner",
      title: "email",
      render: (owner) => owner?.email,
    },
    {
      key: "phone_number",
      dbColName: "owner",
      title: "phone number",
      render: (owner) => formatPhone(owner?.phone_number),
    },
    {
      key: "companyType",
      dbColName: "companyType",
      title: "company type",
    },
    {
      key: "campaignStatus",
      dbColName: "campaignStatus",
      title: "campaign Status",
    },
    {
      key: "createdAt",
      dbColName: "createdAt",
      title: "created At",
      render: (date) => formatDate(date),
    },
    {
      key: "action",
      freeze: true,
      freezeIndex: "right-0",
      title: "action",
      render: (row) => {
        return (
          <div>
            <button
              type="button"
              onClick={() =>
                router.push(
                  `/company-details/${row.companyId}/${row?.owner?.badgeId}`
                )
              }
              className="text-blue-500"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-6 h-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
                />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                />
              </svg>
            </button>
            <button
              type="button"
              onClick={() => {
                setShowModal(true)
                setState({
                  ...state,
                  title: row.title,
                  products: row.products,
                  hierarchy: row.hierarchy,
                  office_locations: row.office_locations,
                  website: row.website,
                  social_media: row.social_media,
                  first_name: row.owner.first_name,
                  campaignStatus: row.campaignStatus,
                  last_name: row.owner.last_name,
                  phone: row.owner.phone_number,
                  email: row.owner.email,
                })
                setSelectedId(row.companyId)
                setIsEditing(true)
              }}
              className="p-2 text-xs text-blue-500 rounded-md "
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-6 h-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10"
                />
              </svg>
            </button>
            <button
              type="button"
              className="text-right text-red-500"
              onClick={() => handleDelete(row.companyId)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-6 h-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
                />
              </svg>
            </button>
          </div>
        )
      },
    },
  ]

  const [state, setState] = useState<any>({
    title: "",
    products: [],
    campaignStatus: "",
    hierarchy: [],
    office_locations: [
      {
        name: "",
        address: "",
        city: "",
        state: "",
        zip: "",
        country: "",
      },
    ],
    website: "",
    social_media: {},
    first_name: "",
    last_name: "",
    phone: "",
    email: "",
    companyType: "",
  })
  const [selectedId, setSelectedId] = useState<string | null>(null)
  const [isEditing, setIsEditing] = useState(false)
  const [data, setData] = useState<any>([])
  const [loading, setLoading] = useState(false)
  const [showModal, setShowModal] = useState(false)

  const [tab, setTab] = useState("owner")

  const { errorMessage, successMessage } = useNotifications()

  const fetchData = useCallback(() => {
    setLoading(true)
    service
      .getCompanies()
      .then((resp) => {
        setData(resp.data.data)
      })
      .catch((error) => {
        console.log(error)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [])

  useEffect(() => {
    fetchData()
  }, [])

  const [keyInput, setKeyInput] = useState("")
  const [valueInput, setValueInput] = useState("")

  const handleAddPair = () => {
    if (keyInput.trim() !== "") {
      setState((prev) => ({
        ...prev,
        social_media: {
          ...prev.social_media,
          [keyInput]: valueInput,
        },
      }))

      setKeyInput("")
      setValueInput("")
    }
  }

  const handleDeleteSocial = (key) => {
    setState((prev) => {
      const updatedSocialMedia = { ...prev.social_media }
      delete updatedSocialMedia[key]
      return {
        ...prev,
        social_media: updatedSocialMedia,
      }
    })
  }

  const handleDelete = (id: string) => {
    swal({
      title:
        "Are you sure, you want to delete this company, this action cannot be undone?",
      icon: "warning",
      className: "w-[500px]",
      buttons: {
        cancel: {
          text: "Cancel",
          visible: true,
        },
        confirm: {
          text: "Delete",
          className: "bg-primary text-white",
        },
      },
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        service
          .deleteCompany(id)
          .then((resp) => {
            successMessage("Comapny deleted successfully")
            const shallowCopy = [...data]
            const newData = shallowCopy.filter((c) => c.companyId !== id)
            setData(newData)
          })
          .catch((err) => {
            console.log(err)
          })
      }
    })
  }

  // Convert hierarchy array to format needed by react-select
  const options = HIERARCHY.map((item) => ({
    value: item,
    label: item,
    newValue: "",
  }))

  const handleSubmit = (event: SyntheticEvent) => {
    event.preventDefault()

    const hierarchy = state.hierarchy.map((item) => {
      if (item.__isNew__) {
        return item.value
      } else if (item.newValue) {
        return `${item.value}:${item.newValue}`
      }
      return item.value
    })

    const requiredFields = {
      title: state.title,
      first_name: state.first_name,
      last_name: state.last_name,
      phone: state.phone,
      campaignStatus: state.campaignStatus,
      email: state.email,
    }

    const payload = {
      ...state,
      hierarchy: hierarchy,
      products: state.products.map((item) => item.value),
    }

    if (isEditing) {
      service
        .updateCompanyDetails(selectedId, requiredFields)
        .then((resp) => {
          if (resp.data.success) {
            fetchData()
            setShowModal(false)
            setIsEditing(false)
            successMessage("Company updated successfully")
          } else {
            errorMessage(resp.data.message)
          }
        })
        .catch((error) => {
          console.log(error)
          errorMessage("Failed to update company details")
        })
    } else {
      const isFormValid = Object.values(requiredFields).every(
        (field) => field.trim() !== ""
      )

      if (!isFormValid) {
        errorMessage("Please fill all required fields")
        return
      }

      if (state.phone.length !== 10) {
        errorMessage("Please enter 10 digits phone number without country code")
        return
      }

      const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(state.email)
      if (!isValidEmail) {
        errorMessage("Please enter a valid email address")
        return
      }

      service
        .addCompany(payload)
        .then((resp) => {
          if (resp.data.success) {
            fetchData()
            successMessage("Company added successfully")
            setState({
              ...state,
              title: "",
              first_name: "",
              last_name: "",
              phone: "",
              email: "",
            })
            setShowModal(false)
            setTab("owner")
          } else {
            errorMessage(resp.data.message)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    }
  }

  const handleChangePhone = (e) => {
    let input = e.target.value

    // Remove any non-digit characters
    input = input.replace(/\D/g, "")

    // Limit to 10 digits maximum
    if (input.length > 10) {
      input = input.slice(0, 10)
    }

    setState({ ...state, phone: input })
  }

  const handleKeyPress = (e) => {
    // Only allow digits
    if (
      !/\d/.test(e.key) &&
      !["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"].includes(e.key)
    ) {
      e.preventDefault()
    }
  }

  const handleExport = () => {
    exportToCSV(data, "dealership")
  }

  const handleChange = (event, index) => {
    const newValue = event.target.value
    const shallowCopy = { ...state }

    shallowCopy.hierarchy[index] = {
      ...shallowCopy.hierarchy[index],
      newValue,
    }
    setState(shallowCopy)
  }

  const handleAddLocation = () => {
    setState({
      ...state,
      office_locations: [
        ...state.office_locations,
        { name: "", address: "", city: "", state: "", zip: "", country: "" },
      ],
    })
  }

  const handleChangeLocation = (event, index) => {
    const { name, value } = event.target
    const shallowCopy = [...state.office_locations]

    shallowCopy[index][name] = value
    setState({ ...state, office_locations: shallowCopy })
  }

  return (
    <Fragment>
      <div className="flex items-center justify-between mb-4">
        <div>
          <h1 className="page-title">
            Dealership
          </h1>
          <p className="page-subtitle">View all </p>
        </div>
        <button
          type="button"
          onClick={() => setShowModal(true)}
          className="bg-ink hover:bg-gray-800 text-white rounded-lg px-4 py-2.5 gap-2 text-sm flex items-center"
        >
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-5 h-5"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 6v12m6-6H6"
              />
            </svg>
          </span>
          Add Company
        </button>
      </div>

      <Table
        data={data}
        loadingData={loading}
        handleExport={handleExport}
        totalItems={data.length}
        exportButton={false}
        columns={columns}
      />
      <Modal
        width="w-full md:w-1/3"
        showModal={showModal}
        setIsEditing={setIsEditing}
        onClose={() => {
          setShowModal(false)
          setIsEditing && setIsEditing(false)
          setState({
            ...state,
            title: "",
            products: [],
            hierarchy: [],
            office_locations: [
              {
                name: "",
                address: "",
                city: "",
                state: "",
                zip: "",
                country: "",
              },
            ],
            website: "",
            social_media: {},
            first_name: "",
            last_name: "",
            phone: "",
            email: "",
          })
        }}
        setShowModal={setShowModal}
        title={isEditing ? "Edit Company" : "Add Company"}
      >
        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          {tab === "owner" ? (
            <>
              <input
                type="text"
                value={state.title}
                placeholder="Company Name"
                onChange={(e) => setState({ ...state, title: e.target.value })}
                className="w-full px-3 py-2 text-sm"
              />
              <input
                type="text"
                placeholder="First Name"
                value={state.first_name}
                onChange={(e) =>
                  setState({ ...state, first_name: e.target.value })
                }
                className="w-full px-3 py-2 text-sm"
              />
              <input
                type="text"
                placeholder="Last Name"
                value={state.last_name}
                onChange={(e) =>
                  setState({ ...state, last_name: e.target.value })
                }
                className="w-full px-3 py-2 text-sm"
              />
              <input
                type="email"
                placeholder="Email"
                value={state.email}
                onChange={(e) => setState({ ...state, email: e.target.value })}
                className="w-full px-3 py-2 text-sm"
              />
              <input
                type="number"
                value={state.phone}
                placeholder="Phone"
                onChange={handleChangePhone}
                onKeyDown={handleKeyPress}
                className="w-full px-3 py-2 text-sm"
              />
              <select
                value={state.campaignStatus}
                onChange={(e) =>
                  setState({ ...state, campaignStatus: e.target.value })
                }
                className="w-full px-3 py-2 text-sm"
              >
                <option value="">Status</option>
                {["Active", "Paused", "Inactive"].map((status) => (
                  <option key={status} value={status}>
                    {status}
                  </option>
                ))}
              </select>
              <select
                value={state.companyType}
                onChange={(e) =>
                  setState({ ...state, companyType: e.target.value })
                }
                className="w-full px-3 py-2 text-sm"
              >
                <option value="">Company Type</option>
                {["Enterprise", "Normal"].map((status) => (
                  <option key={status} value={status}>
                    {status}
                  </option>
                ))}
              </select>
            </>
          ) : tab === "details" ? (
            <>
              <div className="flex flex-col gap-1.5">
                <label className="field-label">Hierarchy</label>
                <CreatableSelect
                  isClearable
                  isMulti
                  options={options}
                  onChange={(value) => setState({ ...state, hierarchy: value })}
                  classNamePrefix="react-select"
                  className="react-select"
                  placeholder="Select or type to add new value"
                  formatCreateLabel={(inputValue) => `Add "${inputValue}"`}
                />
                {state.hierarchy.length > 0 &&
                  state.hierarchy.map((item, index) => (
                    <div
                      key={index}
                      className="flex overflow-hidden border border-gray-300 rounded-md focus:ring-0 focus:border-gray-400"
                    >
                      <p className="text-sm whitespace-nowrap pt-2.5 px-3 bg-gray-100 top-0.5  rounded-l-md  overflow-hidden">
                        {item.label}
                      </p>
                      <input
                        type="text"
                        placeholder="Modify value"
                        onChange={(event) => handleChange(event, index)}
                        value={item.newValue}
                        disabled={item.__isNew__}
                        className="border-none disabled:cursor-not-allowed  disabled:bg-gray-100 focus:ring-0 overflow-hidden focus:border-none flex-1 focus:outline-none  px-3 py-2.5 text-sm text-gray-800"
                      />
                    </div>
                  ))}
              </div>
              <div className="flex flex-col gap-1.5">
                <label className="field-label">Products</label>
                <CreatableSelect
                  isClearable
                  isMulti
                  options={state.products}
                  onChange={(value) => setState({ ...state, products: value })}
                  classNamePrefix={"react-select"}
                  className="react-select"
                  placeholder="Type and press enter to add"
                  formatCreateLabel={(inputValue) => `Add "${inputValue}"`}
                />
              </div>
              {/* <div className="flex flex-col gap-1.5">
                <label className="field-label">
                  Office Locations
                </label>
                <CreatableSelect
                  isClearable
                  isMulti
                  options={state.office_locations}
                  onChange={(value) =>
                    setState({ ...state, office_locations: value })
                  }
                  classNamePrefix={"react-select"}
                  className="react-select"
                  placeholder="Type and press enter to add"
                  formatCreateLabel={(inputValue) => `Add "${inputValue}"`}
                />
              </div> */}

              <div>
                <label className="field-label">Website</label>
                <div className="flex items-center gap-2 mt-1.5">
                  <input
                    type="text"
                    placeholder="Key"
                    value={keyInput}
                    onChange={(e) => setKeyInput(e.target.value)}
                    className="w-full px-3 py-2 text-sm"
                  />
                  <input
                    type="text"
                    placeholder="Value"
                    value={valueInput}
                    onChange={(e) => setValueInput(e.target.value)}
                    className="w-full px-3 py-2 text-sm"
                  />
                  <button
                    type="button"
                    onClick={handleAddPair}
                    className="px-3 py-2 text-sm text-white bg-ink hover:bg-gray-800 rounded"
                  >
                    Add
                  </button>
                </div>

                <ul className="mt-2">
                  {Object.entries(state.social_media).map(
                    ([key, value]: any) => (
                      <li
                        key={key}
                        className="flex items-center justify-between mb-1"
                      >
                        <span>
                          {key}: {value}
                        </span>
                        <button
                          onClick={() => handleDeleteSocial(key)}
                          type="button"
                          className="text-sm text-red-500"
                        >
                          Delete
                        </button>
                      </li>
                    )
                  )}
                </ul>
              </div>
              <div className="flex flex-col gap-1.5">
                <label className="field-label">Website</label>
                <input
                  type="text"
                  value={state.website}
                  placeholder="Website"
                  onChange={(e) =>
                    setState({ ...state, website: e.target.value })
                  }
                  className="w-full px-3 py-2 text-sm"
                />
              </div>
            </>
          ) : (
            <div className="flex flex-col gap-4">
              {state.office_locations.map((item, index) => (
                <div className="grid grid-cols-2 gap-4">
                  <input
                    type="text"
                    name="name"
                    placeholder="Location Name"
                    value={item.name}
                    onChange={(e) => handleChangeLocation(e, index)}
                    className="w-full px-3 py-2 text-sm"
                  />
                  <input
                    type="text"
                    name="address"
                    placeholder="Address"
                    value={item.address}
                    onChange={(e) => handleChangeLocation(e, index)}
                    className="w-full px-3 py-2 text-sm"
                  />
                  <input
                    type="text"
                    name="city"
                    placeholder="City"
                    value={item.city}
                    onChange={(e) => handleChangeLocation(e, index)}
                    className="w-full px-3 py-2 text-sm"
                  />
                  <input
                    type="text"
                    name="state"
                    placeholder="State"
                    value={item.state}
                    onChange={(e) => handleChangeLocation(e, index)}
                    className="w-full px-3 py-2 text-sm"
                  />

                  <input
                    type="text"
                    name="zip"
                    placeholder="Zip"
                    value={item.zip}
                    onChange={(e) => handleChangeLocation(e, index)}
                    className="w-full px-3 py-2 text-sm"
                  />
                  <input
                    type="text"
                    name="country"
                    placeholder="Country"
                    value={item.country}
                    onChange={(e) => handleChangeLocation(e, index)}
                    className="w-full px-3 py-2 text-sm"
                  />
                </div>
              ))}
              <button
                type="button"
                onClick={handleAddLocation}
                className="px-3 py-2 text-sm text-white bg-ink hover:bg-gray-800 rounded place-self-start"
              >
                Add Location
              </button>
            </div>
          )}
          <button
            type="submit"
            className="bg-ink hover:bg-gray-800 disabled:cursor-not-allowed rounded-lg font-medium text-sm disabled:bg-green-300 text-white p-2.5"
          >
            {isEditing ? "Update" : "Add"} Company
          </button>
        </form>
      </Modal>
    </Fragment>
  )
}
